import FilterPanel from "./filterPanel";

export default FilterPanel;
